import { render, staticRenderFns } from "./contract-recall.vue?vue&type=template&id=ae4ea3b8&scoped=true"
import script from "./contract-recall.vue?vue&type=script&lang=js"
export * from "./contract-recall.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=ae4ea3b8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4ea3b8",
  null
  
)

export default component.exports